/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespHeroModuleOld_componentModule = {
    readonly title: string | null;
    readonly items: ReadonlyArray<{
        readonly cmsId: number | null;
        readonly link: string | null;
        readonly imageUrl: string | null;
        readonly title: string | null;
        readonly contemporaryTrackingString: string | null;
    } | null> | null;
    readonly " $refType": "HpRespHeroModuleOld_componentModule";
};
export type HpRespHeroModuleOld_componentModule$data = HpRespHeroModuleOld_componentModule;
export type HpRespHeroModuleOld_componentModule$key = {
    readonly " $data"?: HpRespHeroModuleOld_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespHeroModuleOld_componentModule">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "HpRespHeroModuleOld_componentModule",
  "type": "HeroModule",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": "Product",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cmsId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "link",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageUrl",
          "args": null,
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "contemporaryTrackingString",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'd766d62b3702385e704ef325aed8ed4d';
export default node;
